import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { useLocation, useNavigate } from 'react-router'
import BoxIcon from '../svgr/Box'
import LightningIcon from '../svgr/Lightning'
import FAQIcon from '../svgr/Faq'
import ProfileIcon from '../svgr/Profile'
import { NavItem } from './NavItem'
import { FormattedMessage } from 'react-intl'
import { colors } from '../styles/colors'
import { bonusReferralsPagePath, bonusTasksPagePath } from '../pages/BonusPage'
import { profileVotesPagePath } from '../pages/ProfilePage'
import { indexPagePath } from '../pages/IndexPage'
import { faqPagePath } from '../pages/FaqPage'
import { useAppContext } from '../contexts/App.context'

type NavRoute = {
  path: string
  icon: React.ReactNode
  formattedMessage: React.ReactNode
  hasNotification?: boolean
  activeMatchRoutes?: string[]
}

const NAV_ROUTES: NavRoute[] = [
  {
    path: indexPagePath,
    icon: <BoxIcon />,
    formattedMessage: (
      <FormattedMessage id="nav.boxes" defaultMessage="Боксы" />
    ),
  },

  {
    path: bonusTasksPagePath,
    activeMatchRoutes: [bonusTasksPagePath, bonusReferralsPagePath],
    icon: <LightningIcon />,
    formattedMessage: (
      <FormattedMessage id="nav.bonuses" defaultMessage="Бонусы" />
    ),
  },

  {
    path: faqPagePath,
    icon: <FAQIcon />,

    formattedMessage: (
      <FormattedMessage id="nav.knowledge" defaultMessage="База знаний" />
    ),
  },

  {
    path: profileVotesPagePath,
    icon: <ProfileIcon />,
    formattedMessage: (
      <FormattedMessage id="nav.profile" defaultMessage="Профиль" />
    ),
  },
]

export const BottomNavigation: FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { authenticated, userProfile } = useAppContext()

  // Calculate if profile has claimable rewards
  const hasClaimableRewards =
    authenticated && userProfile && Number(userProfile.unclaimedVoteCount) > 0

  return (
    <NavigationContainer>
      {NAV_ROUTES.map(route => {
        // For profile route, use dynamic notification logic
        const hasNotification =
          route.path === profileVotesPagePath
            ? hasClaimableRewards
            : route.hasNotification

        return (
          <NavItem
            key={route.path}
            icon={route.icon}
            isActive={
              route.activeMatchRoutes
                ? route.activeMatchRoutes.includes(location.pathname)
                : location.pathname === route.path
            }
            hasNotification={hasNotification}
            onClick={() => navigate(route.path)}
            formattedMessage={route.formattedMessage}
          />
        )
      })}
    </NavigationContainer>
  )
}

const NavigationContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: var(--bottom-navigation-height);
  background: ${colors.surfacePrimary};
  border-top: 1px solid ${colors.borderSecondary};
  padding: 0;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  z-index: 1000;

  @media (max-width: 768px) {
    height: auto;
    min-height: var(--bottom-navigation-height, 64px);
  }

  @media (max-width: 480px) {
    padding: 0;
  }
`
